import style from "./account.module.scss";
import PropTypes from "prop-types";

const AccountProfile = ({ name, email, isEmailVisible }) => {
  // isEmailVisible is true for individual users, false for institutions
  return (
    <div className={style.accountProfile}>
      <div className={style.logoContainer}>
        <img
          src="/TherapeuticGuidelines_Original_R_Logo.svg"
          className="account_tg_logo"
          alt="profile tg logo"
          width="160"
          height="60"
          border="0"
        ></img>
      </div>

      {name && <p className={style.name}>{name}</p>}
      {isEmailVisible && email && <p className={style.email}>{email}</p>}
      {!name && !email && (
        <p className={style.noname}>
          Log in or subscribe to manage account details
        </p>
      )}
    </div>
  );
};

AccountProfile.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  isEmailVisible: PropTypes.bool,
};

export default AccountProfile;
